import React, { useEffect, useState, useMemo } from "react";
import { motion } from "framer-motion";
import i18n from "i18next";

//CSS
import "../0PageStyles.css";
import "./generalSettingsPage.css";

//Components
import Button from "../../Components/Other Components/button";
import InputField from "../../Components/Other Components/inputField";
import InputGroup from "../../Components/Other Components/inputGroup";
import Title from "../../Components/Other Components/Title";

//Functions and hooks
import { GetWarehouseCount } from "../../BackendAccess/WarehouseHooks";
import { GetUserInfo } from "../../BackendAccess/UserHooks";
import { GetLink } from "../../BackendAccess/FrontendHelpers";
import { CreateItem } from "../../BackendAccess/ItemHooks";
import { useNotification } from "../../Contexts/NotificationContext";
import {
  GetItemsPerWarehouse,
  GetItemsPerClient,
} from "../../BackendAccess/ItemHooks";
import { useSettings, formatCurrency } from "../../Contexts/SettingsContext";
import {
  UpdateUserSettings,
  UpdateCompanySettings,
} from "../../BackendAccess/SettingsHooks";
import PageWrapper from "../pageWrapper";
import PageLoader from "../../Components/Other Components/pageLoader";
import { useTranslation } from "react-i18next";

export default function GeneralSettingsPage({}) {
  // Replace separate states with a single object
  const [userSettingsData, setUserSettingsData] = useState({
    textScale: "default",
    darkMode: true,
    notifications: true,
    language: "en",
    startPage: "Warehouses",
  });

  const [pageError, setPageError] = useState(null);
  const [loading, setLoading] = useState(false);

  const { showNotification } = useNotification();

  const { t } = useTranslation();

  const [userSettingsSet, setUserSettingsSet] = useState(false);

  const {
    userSettings,
    companySettings,
    updateUserSettingsLocally,
    refreshUserSettings,
    refreshCompanySettings,
  } = useSettings();

  const handleUserSettingsChange = (field, value) => {
    const updatedSettings = {
      ...userSettingsData,
      [field]: value,
    };

    setUserSettingsData(updatedSettings);

    if (field === "language") {
      i18n.changeLanguage(value);
    }

    const fieldMapping = {
      textScale: "scale",
      darkMode: "theme",
      notifications: "notificationsEnabled",
      language: "language",
      startPage: "startPage",
    };

    const backendField = fieldMapping[field];
    let backendValue = value;

    if (field === "darkMode") {
      backendValue = value ? "dark" : "light";
    }

    const updatedBackendSettings = {
      ...userSettings,
      [backendField]: backendValue,
    };

    console.log("New usert settings", updatedBackendSettings);

    updateUserSettingsLocally(updatedBackendSettings);
    UpdateUserSettings(updatedBackendSettings);
  };

  const settingsArray = useMemo(() => {
    console.log("Testing dark mode", userSettingsData);
    return [
      {
        CategoryName: t("Appearance & Behavior", { ns: "settings" }),
        CategorySettings: [
          {
            Name: t("Text Scale", { ns: "settings" }),
            Placeholder: "Enter a value between 0 and 10",
            Type: "dropdown",
            Options: ["small", "default", "large"],
            Value: userSettingsData.textScale,
            OnChange: (val) => {
              handleUserSettingsChange("textScale", val);
            },
            SortType: "",
            TutorialId: "settings-text-scale",
          },
          {
            Name: t("Dark Mode", { ns: "settings" }),
            Type: "checkbox",
            Key: "darkMode",
            Value: userSettingsData.darkMode,
            OnChange: (val) => {
              handleUserSettingsChange("darkMode", val);
            },
            TutorialId: "settings-dark-mode",
          },
          {
            Name: t("Enable Notifications", { ns: "settings" }),
            Type: "checkbox",
            Key: "notifications",
            Value: userSettingsData.notifications,
            OnChange: (val) => {
              handleUserSettingsChange("notifications", val);
            },
            TutorialId: "settings-notifications",
          },
        ],
      },
      {
        CategoryName: t("Localization & Startup", { ns: "settings" }),
        CategorySettings: [
          {
            Name: t("Language", { ns: "settings" }),
            Type: "dropdown",
            Options: [
              { label: "English", value: "en" },
              { label: "Srpski", value: "rs" },
            ],
            Value: userSettingsData.language,
            OnChange: (val) => {
              handleUserSettingsChange("language", val);
            },
            TutorialId: "settings-language",
          },
          {
            Name: t("Start Page", { ns: "settings" }),
            Type: "dropdown",
            Options: [
              { label: t("Warehouses"), value: "warehouses" },
              { label: t("Items"), value: "items" },
              { label: t("Units"), value: "units" },
              { label: t("Tags"), value: "tags" },
              { label: t("Traffic"), value: "traffic" },
              { label: t("Roles"), value: "roles" },
              { label: t("Employees"), value: "employees" },
              { label: t("Clients"), value: "clients" },
            ],
            Value: userSettingsData.startPage,
            OnChange: (val) => {
              handleUserSettingsChange("startPage", val);
            },
            TutorialId: "settings-start-page",
          },
        ],
      },
    ];
  }, [userSettingsData, userSettingsSet, t]);

  useEffect(() => {
    const storedSettingsString = window.localStorage.getItem("User settings");
    const storedSettings = JSON.parse(storedSettingsString);

    if (storedSettings && !userSettingsSet) {
      setUserSettingsData({
        darkMode: storedSettings.theme === "dark",
        language: storedSettings.language,
        textScale: storedSettings.scale,
        notifications: storedSettings.notificationsEnabled,
        startPage: storedSettings.startPage || "",
      });

      console.log(
        "Testing user update settings",
        storedSettings.theme,
        storedSettings.theme === "dark",
        storedSettings
      );

      i18n.changeLanguage(storedSettings.language);
      setUserSettingsSet(true);
    }
    console.log(
      "Testing user update settings falseeee",
      storedSettings,
      storedSettingsString,
      userSettingsSet
    );
  }, []);

  const createSettings = () => {
    let ZCounter = settingsArray.length + 1;
    return settingsArray.map((settingCategory, index) => {
      ZCounter--;
      return (
        <div
          className="general-settings-category"
          style={{ zIndex: ZCounter }}
          key={settingCategory.CategoryName}
        >
          <span className="general-settings-category-title">
            {settingCategory.CategoryName}:
          </span>
          <InputGroup className="general-settings-category-list">
            {settingCategory.CategorySettings.map((setting) => {
              return (
                <InputField
                  key={setting.Name}
                  label={setting.Name + ":"}
                  onChange={setting.OnChange}
                  type={setting.Type ?? ""}
                  placeholder={setting.Placeholder ?? ""}
                  options={setting.Options ?? []}
                  value={setting.Value}
                  min={setting.Min ?? null}
                  max={setting.Max ?? null}
                  step={setting.Step ?? null}
                  copyEnabled={false}
                  dropdownSortType={setting.SortType}
                  tutorialId={setting.TutorialId}
                />
              );
            })}
          </InputGroup>
        </div>
      );
    });
  };

  const tutorialSteps = [
    {
      target: null,
      title: t("General settings", { ns: "tutorial" }),
      message: t(
        "This page controls how the app looks and behaves for you personally - these settings don't affect anyone else in your company.",
        { ns: "tutorial" }
      ),
    },
    {
      target: "settings-text-scale",
      title: t("Text Scale", { ns: "tutorial" }),
      message: t(
        "Make text and interface elements smaller or larger across the whole app.",
        { ns: "tutorial" }
      ),
    },
    {
      target: "settings-dark-mode",
      title: t("Dark Mode", { ns: "tutorial" }),
      message: t(
        "Switch between a dark and a light color theme.",
        { ns: "tutorial" }
      ),
    },
    {
      target: "settings-notifications",
      title: t("Enable Notifications", { ns: "tutorial" }),
      message: t(
        "Turn in-app notifications on or off.",
        { ns: "tutorial" }
      ),
    },
    {
      target: "settings-language",
      title: t("Language", { ns: "tutorial" }),
      message: t(
        "Switch the app's language between English and Serbian.",
        { ns: "tutorial" }
      ),
    },
    {
      target: "settings-start-page",
      title: t("Start Page", { ns: "tutorial" }),
      message: t(
        "Choose which page you land on right after logging in.",
        { ns: "tutorial" }
      ),
    },
  ];

  return (
    <PageWrapper tutorialId="generalSettings" tutorialSteps={tutorialSteps}>
      <PageLoader loading={loading} error={pageError}>
        <div className="page-content">
          <Title className="mt-3">General settings</Title>
          <div className="general-settings-page">{createSettings()}</div>
        </div>
      </PageLoader>
    </PageWrapper>
  );
}
